require('./action-guide.scss')
import angular from 'angular';

import AnalyticsServ from '../../services/analytics';
import ActionGuideServ from '../../services/action-guide';


function ActionGuide(ActionGuideServ, $window, $timeout, $rootScope) {
  return {
    restrict: 'E',
    template: require('./action-guide.html'),
    link: (scope, element, attrs) => {

      $timeout(() => {
        var openerActionGuide;
        scope.context = attrs.context;
        if ($window.isFactWindow && $window.opener && $window.opener.angular) {
          openerActionGuide = $window.opener.angular.element(
            $window.opener.document.querySelector('[ng-app]')
          ).injector().get('ActionGuideServ')
        }
        scope.actionGuide = openerActionGuide || ActionGuideServ
          // pass a callback so the service can search the given with a target selector
        scope.actionGuide.connect(scope.context, target =>
          target === 'window' ? window : document.querySelector(target)
        )
        scope.actionGuide.setGuide('full')
      })
      $rootScope.$on('$routeChangeSuccess', () => {
        scope.actionGuide.success()
      })
      $rootScope.$on('$routeChangeStart', (e, next) => {
        if (!/home|fact/.test(next.$$route.originalPath)) {
          element[0].remove();
        }
      })
      scope.$on('$destroy', () => {
        scope.actionGuide.unbindWatchers()
      })

    }
  };
}
ActionGuide.$inject = ['ActionGuideServ', '$window', '$timeout', '$rootScope'];

export default angular.module('directives.lf-action-guide', [
    AnalyticsServ,
    ActionGuideServ
  ])
  .directive('lfActionGuide', ActionGuide)
  .name;



// WEBPACK FOOTER //
// ./project/directives/lf-action-guide/index.js